import { render, staticRenderFns } from "./CustomerStep.vue?vue&type=template&id=061a8594&scoped=true&"
import script from "./CustomerStep.vue?vue&type=script&lang=js&"
export * from "./CustomerStep.vue?vue&type=script&lang=js&"
import style0 from "./CustomerStep.vue?vue&type=style&index=0&id=061a8594&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "061a8594",
  null
  
)

export default component.exports